// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  packId: __t.u64().primaryKey().name("pack_id"),
  name: __t.string(),
  uri: __t.string(),
  sizeBytes: __t.u64().name("size_bytes"),
  members: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
